import React from "react";
import { Card, Progress, Typography } from "@payping/web-components";
import { webConstants } from "@payping/utils/platformConstants";
import { Trans } from "@payping/utils/localeUtils";
import { safeJoinPath } from "@payping/utils/string";

import { useAppTranslation } from "@/utils/useAppTranslation";
import { profileCompletionId } from "@/assets/googleTrackIds";
import styles from "../../../assets/scss/BlackFriday.module.scss";

const TransactionRemaining: React.FC<{ count: number }> = ({ count }) => {
  const { t } = useAppTranslation();
  const percent = count * 20;
  const requiredCount = 5;
  const finished = count === requiredCount;
  const { STORAGE_URL } = webConstants;
  const cartSrc = safeJoinPath(STORAGE_URL, "img/blackFriday/blackFriday-cart-black.png");

  return (
    <Card.Raw data-google-track={profileCompletionId} className={styles.campaignCard}>
      <div className={styles.cardTitle}>
        <Typography.Text>{t("overview.blackFriday.title")}</Typography.Text>
        <img height={"35"} src={cartSrc} />
      </div>
      {!finished ? (
        <>
          <span className={styles.progressWrapper}>
            <Progress
              strokeColor={{ from: "#108ee9", to: "#87d068" }}
              percent={percent}
              status={"active"}
              strokeWidth={15}
              showInfo={false}
            />
            <span>
              {count} {t("common.of")} {requiredCount}
            </span>
          </span>
          <Typography.Text style={{ fontSize: "11px" }}>
            {t("overview.blackFriday.remainingTransaction", { count: requiredCount - count })}
          </Typography.Text>
        </>
      ) : (
        <Typography.Text style={{ marginBottom: "12px" }}>
          <Trans i18nKey={"Wrapper:overview.blackFriday.finishedTransaction"} components={[<b key={0} />]} />
        </Typography.Text>
      )}
    </Card.Raw>
  );
};

export default TransactionRemaining;
